export default __webpack_public_path__ + "static/media/IconDesc_Biomass_Final.256.184989b9.png";